<form [formGroup]="form">
  <div class="landingRadioGroup mb-3 row">
    <div class="col-12">
      <mwp-radio-button [form]="form" [nameForControl]="nameForRadioControl" [dataEnum]="agentLocationEnum" [noSpacing]="true" (emitSelected)="radioChange($event)" [autoTranslate]="true" />
    </div>
  </div>
  @if (displayWorkSiteInfo) {
    <div class="mb-3">
      <form [formGroup]="locationFormGroup">
        <div class="mb-3">
          <mwp-input [form]="locationFormGroup" labelName="City" nameForControl="agentCity" />
        </div>
        <div>
          <mwp-dropdown-enum [form]="locationFormGroup" labelName="State" nameForControl="agentState" [dataEnum]="usStates" [autoTranslate]="true" />
        </div>
      </form>
    </div>
  }
</form>